// Périodes du bandeau « présents / absents » (jours de Paris, bornes incluses).
import { addDaysIso } from "@shared/followup";

export type CallPeriodKey = "week" | "lastWeek" | "month" | "lastMonth";

const MONTHS = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
];

const pad2 = (n: number) => String(n).padStart(2, "0");

function monthRange(year: number, month0: number) {
  const last = new Date(Date.UTC(year, month0 + 1, 0)).getUTCDate();
  const ym = `${year}-${pad2(month0 + 1)}`;
  return { from: `${ym}-01`, to: `${ym}-${pad2(last)}`, label: MONTHS[month0], month: ym };
}

export function callPeriodRange(
  key: CallPeriodKey,
  today: string,
): { from: string; to: string; label: string; month: string } {
  const [y, m, d] = today.split("-").map(Number);
  if (key === "month") return monthRange(y, m - 1);
  if (key === "lastMonth") return m === 1 ? monthRange(y - 1, 11) : monthRange(y, m - 2);
  const dow = (new Date(Date.UTC(y, m - 1, d)).getUTCDay() + 6) % 7; // lundi = 0
  const monday = addDaysIso(today, -dow)!;
  const base =
    key === "week"
      ? { from: monday, to: today, label: "Cette semaine" }
      : { from: addDaysIso(monday, -7)!, to: addDaysIso(monday, -1)!, label: "Semaine passée" };
  return { ...base, month: base.to.slice(0, 7) };
}
